// Legacy jQuery vendor stack — the ESM replacement for the old `app.import()` +
// /@embroider/virtual/vendor.js pipeline (config/vendor-files.js). Imported first in
// app/app.ts.
//
// Ordering: `jquery-globals` (imported first) sets the shared global jQuery
// (window.$ / window.jQuery). The plugins below read a bare global `jQuery`/`$` at
// module-eval time. They declare no import of the global-setter, so the production
// bundler is otherwise free to evaluate a plugin before it ("jQuery is not defined").
// The `inject-jquery-global` Vite plugin (see vite.config.mjs) prepends a
// `jquery-globals` import to each of these plugin modules at build time, giving them a
// real dependency edge that forces the global-setter to evaluate first.
//
// Each library's JS + CSS are kept together.
import 'webapp/vendor/jquery-globals';
//
// jQueryUI (order matters: core deps before the widgets that use them)
import 'jquery-ui/ui/version.js';
import 'jquery-ui/ui/plugin.js';
import 'jquery-ui/ui/keycode.js';
import 'jquery-ui/ui/disable-selection.js';
import 'jquery-ui/ui/scroll-parent.js';
import 'jquery-ui/ui/data.js';
import 'jquery-ui/ui/widget.js';
import 'jquery-ui/ui/widgets/mouse.js';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
import 'jquery-ui/ui/widgets/resizable.js';
import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery-ui/ui/widgets/slider.js';
import 'jquery-ui/ui/effect.js';
import 'jquery-ui/ui/effects/effect-shake.js';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/themes/base/sortable.css';
import 'jquery-ui/themes/base/slider.css';
//
// makes jQuery UI draggable/sortable work with touch events.
import '/vendor/libs/jquery.ui.touch-punch.min.js';
// select2 — install (its UMD exports a factory under a bundler) + CSS, co-located in
// its own module.
import 'webapp/vendor/select2';
//
// floatlabel
import 'floatlabels.js/floatlabels.js';
//
// gridboard
import 'gridboard/dist/gridboard.min.js';
import 'gridboard/dist/gridboard.css';
//
// colpick
import 'jquery-colpick/js/colpick.min.js';
import 'jquery-colpick/css/colpick.min.css';
//
// timepicker
import '/vendor/libs/timepicker/jquery.timepicker.min.js';
import '/vendor/libs/timepicker/jquery.timepicker.min.css';
//
// periodpicker — the following change was made to fix not working events https://github.com/databox/webapp/commit/fa8353a10a50f5ff5caa4d8934e632a4b1f8da6c plus PR https://github.com/databox/webapp/pull/3736. Prevent checking to_time when norange is enabled, look comment on https://github.com/databox/webapp/pull/3858#pullrequestreview-519098370. Also placement logic change: https://github.com/databox/webapp/pull/4119/commits/1190f18f86599c8c88fd885cb014a66fd5944912. Also https://github.com/databox/webapp/commit/0b2e04ae4374102876d1bc3e33c96338eba26c7d because of https://github.com/xdan/periodpicker/issues/69. And also always closing with animation https://github.com/databox/webapp/commit/249076e1e6bf2e84b00e6715b17df42e6a099c68.
import '/vendor/libs/periodpicker/jquery.periodpicker.min.js';
import '/vendor/libs/periodpicker/jquery.periodpicker.min.css';
//
// lazyLoadXT
import 'lazyloadxt/dist/jquery.lazyloadxt.min.js';
//
// rippler
import 'rippler/dist/js/rippler.min.js';
import 'rippler/dist/css/rippler.min.css';
//
// slick
import 'slick-carousel/slick/slick.min.js';
import 'slick-carousel/slick/slick.css';
//
// tooltipster
import 'tooltipster/dist/js/tooltipster.bundle.min.js';
import 'tooltipster/dist/css/tooltipster.bundle.min.css';
//
// Confetti
import '/vendor/libs/Confetti.min.js';
//
// Handsontable — CSS only; the JS is consumed as an ESM module elsewhere in the app.
import 'handsontable/dist/handsontable.full.min.css';
//
// Highcharts — CSS only; the JS is consumed as an ESM module elsewhere in the app.
import 'highcharts/css/highcharts.css';
